export const BASE_CUSTOM_CLASSNAME = 'directory-favorites__directory';
export const NAMESPACE = 'directory-entries';
export const DOMAIN = 'directories';
export const DEFAULT_DIRECTORY_ICON = 'book-multiple';
